import { useAppStore } from '../store'

export function LoadingOverlay() {
  const ready = useAppStore((s) => s.modelReady)
  const err = useAppStore((s) => s.modelError)
  const progress = useAppStore((s) => s.loadProgress)
  if (ready && !err) return null
  return (
    <div className="loading-overlay">
      <div>
        <h2>Yoga Anatomy Studio</h2>
        {err ? <p className="error">{err}</p> : (
          <>
            <p>Loading skinned female rig…</p>
            <div className="progress"><div style={{ width: `${Math.round(progress * 100)}%` }} /></div>
          </>
        )}
      </div>
    </div>
  )
}
